(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
const wrappers = document.querySelectorAll('.footer-block__wrapper');

wrappers.forEach((wrapper) => {
wrapper.addEventListener('click', function () {
const detailsContent = wrapper.nextElementSibling;
const icon = wrapper.querySelector('.footer-block__plus');
const path = icon.querySelector('path');

if (detailsContent.classList.contains('visible')) {
detailsContent.classList.remove('visible');
path.setAttribute('d', 'M12.5 0v24M24 12H0'); // Set to plus sign
icon.classList.remove('rotated'); // Remove rotated class
} else {
detailsContent.classList.add('visible');
path.setAttribute('d', 'M0 12h24'); // Set to minus sign
icon.classList.add('rotated'); // Add rotated class
}
});
});

class LocalizationForm extends HTMLElement {
constructor() {
super();
this.elements = {
input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
button: this.querySelector('button'),
panel: this.querySelector('.disclosure__list-wrapper'),
};
this.elements.button.addEventListener('click', this.openSelector.bind(this));
this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
}

hidePanel() {
this.elements.button.setAttribute('aria-expanded', 'false');
this.elements.panel.setAttribute('hidden', true);
}

onContainerKeyUp(event) {
if (event.code.toUpperCase() !== 'ESCAPE') return;

this.hidePanel();
this.elements.button.focus();
}

onItemClick(event) {
event.preventDefault();
const form = this.querySelector('form');
this.elements.input.value = event.currentTarget.dataset.value;
if (form) form.submit();
}

openSelector() {
this.elements.button.focus();
this.elements.panel.toggleAttribute('hidden');
this.elements.button.setAttribute(
'aria-expanded',
(this.elements.button.getAttribute('aria-expanded') === 'false').toString()
);
}

closeSelector(event) {
const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
if (event.relatedTarget === null || shouldClose) {
this.hidePanel();
}
}
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();
})();
